import FilterSelect from "../../components/FilterSelect/FilterSelect";
import {HISTORY_TYPE, HISTORY_RESULT, HISTORY_FILTER_INITIAL_STATE} from "../../../../../constants/index.jsx";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import FilterInput from "../../components/FilterInput/FilterInput";
import {setHistoryFilter} from "../../../../../redux/actions/history/actions";
import Button from "../../../../../core/Button/Button";
import {closeLobbyModal} from "../../../../../redux/actions/lobby/actions";

function MobileHistoryFilter() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const filter = useSelector(state => state.history.filter);
    const [mobileFilter, setMobileFilter] = useState(filter);
    const {tillValues} = useSelector(state => state.user.config);

    const mapTranslatedOptions = (options, translateLabel = '') => {
        return options.map((option) => {
            return {...option, label: t(`${translateLabel}.${option.label}`)}
        })
    }
    const handleChange = (data) => {
        setMobileFilter((prevState) => {
            return {
                ...prevState,
                ...data
            }
        })
    }
    const closeHistoryModal = () => {
        dispatch(closeLobbyModal());
    }
    const applyFilters = () => {
        dispatch(setHistoryFilter(mobileFilter));
        dispatch(closeLobbyModal());
    }
    const resetFilters = () => {
        dispatch(setHistoryFilter(HISTORY_FILTER_INITIAL_STATE));
        dispatch(closeLobbyModal());
    }

    return <div className="mobile-history-filter--wrapper">
        <div className="mobile-history-filter--row">
            <i
                className="icon-close"
                onClick={() => closeHistoryModal()}
            />
        </div>
        <div className="mobile-history-filter--row">
            <FilterSelect
                data={mapTranslatedOptions(HISTORY_RESULT, "filter")}
                placeholder={mobileFilter?.result?.label || t("filter.history_result")}
                handleChange={handleChange}
                name="result"
            />
            <FilterSelect
                data={[{value: 'all', label: t('filter.all')}, ...tillValues]}
                placeholder={mobileFilter?.till?.label || t("filter.history_till")}
                handleChange={handleChange}
                name="till"
            />
        </div>
        <div className="mobile-history-filter--row">
            <FilterInput
                placeholder={t("filter.min_bet")}
                handleChange={handleChange}
                name="minBet"
                value={mobileFilter.minBet}/>
            <FilterInput
                placeholder={t("filter.max_bet")}
                handleChange={handleChange}
                name="maxBet"
                value={mobileFilter.maxBet}
            />
        </div>
        <div className="mobile-history-filter--row">
            <FilterSelect
                data={mapTranslatedOptions(HISTORY_TYPE, "filter")}
                placeholder={mobileFilter?.type?.label || t("filter.history_type")}
                handleChange={handleChange}
                name="type"
            />
        </div>
        <div className="mobile-history-filter--row">
            <Button
                type={"blue"}
                text={t("filter.apply")}
                onClick={applyFilters}
            />
            <Button
                type={"lightblue"}
                text={t("filter.clear_all")}
                onClick={resetFilters}
            />
        </div>
    </div>
}

export default MobileHistoryFilter;